import axios from 'axios'

export const GET_HOTELS_AVAILABILITIES = window?.drupalSettings?.search?.api?.priceUploadsUrl;
export default async function (parameters, url = GET_HOTELS_AVAILABILITIES) {
  return await axios.post(url, parameters, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
